import React, { Component } from 'react'
import { connect } from 'react-redux'
import AdminComponent from '../components/Admin'
import AdminHome from './AdminHome'
import AdminDocTypes from './AdminDocTypes'
import AdminDocTypesForm from './AdminDocTypesForm'
import AdminEntTypes from './AdminEntTypes'
import AdminEntTypesForm from './AdminEntTypesForm'
import AdminIssues from './AdminIssues'
import AdminIssuesForm from './AdminIssuesForm'
import AdminRoles from './AdminRoles'
import AdminRolesForm from './AdminRolesForm'
import AdminEntities from './AdminEntities'
import AdminEntitiesForm from './AdminEntitiesForm'
import AdminUsers from './AdminUsers'
import AdminUsersForm from './AdminUsersForm'
import AdminActions from './AdminActions'
import AdminActionsForm from './AdminActionsForm'
import AdminPolicies from './AdminPolicies'
import AdminPoliciesForm from './AdminPoliciesForm'
import AdminTemplates from './AdminTemplates'
import AdminTemplatesForm from './AdminTemplatesForm'
import AdminPrograms from './AdminPrograms'
import AdminProgramsForm from './AdminProgramsForm'
import { withRouter, Route, Switch, Redirect } from 'react-router-dom'
import Permissions from '../models/Permissions'
import AuthModel from '../models/AuthModel'

class Admin extends Component {

    render() {
        if (!AuthModel.isAuthenticated()) {
            AuthModel.lastRoute = '/admin'
            return <Redirect to='/login' />
        }
        if (Permissions.isDenied('admin', 'home')) {
            return <Redirect to='/' />
        }
        return (
            <AdminComponent {...this.props} >
                <Switch>
                    <Route exact={true} path="/admin" component={AdminHome} />
                    <Route path="/admin/doctypes/form/:id?" component={AdminDocTypesForm} />
                    <Route path="/admin/doctypes" component={AdminDocTypes} />
                    <Route path="/admin/enttypes/form/:id?" component={AdminEntTypesForm} />
                    <Route path="/admin/enttypes" component={AdminEntTypes} />
                    <Route path="/admin/issues/form/:id?" component={AdminIssuesForm} />
                    <Route path="/admin/issues" component={AdminIssues} />
                    <Route path="/admin/roles/form/:id?" component={AdminRolesForm} />
                    <Route path="/admin/roles" component={AdminRoles} />
                    <Route path="/admin/entities/form/:id?" component={AdminEntitiesForm} />
                    <Route path="/admin/entities" component={AdminEntities} />
                    <Route path="/admin/users/form/:id?" component={AdminUsersForm} />
                    <Route path="/admin/users" component={AdminUsers} />
                    <Route path="/admin/actions/form/:id?" component={AdminActionsForm} />
                    <Route path="/admin/actions" component={AdminActions} />
                    <Route path="/admin/policies/form/:id?" component={AdminPoliciesForm} />
                    <Route path="/admin/policies" component={AdminPolicies} />
                    <Route path="/admin/templates/form/:filename?" component={AdminTemplatesForm} />
                    <Route path="/admin/templates" component={AdminTemplates} />
                    <Route path="/admin/programs/form/:id?" component={AdminProgramsForm} />
                    <Route path="/admin/programs" component={AdminPrograms} />
                </Switch>
            </AdminComponent>
        )
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.auth)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Admin))



// WEBPACK FOOTER //
// ./src/containers/Admin.js